// Multilanguage translations — DE (default), EN, PL
export const translations = {
  de: {
    // Header / Nav
    nav: {
      home: 'Start',
      philosophy: 'Philosophie',
      services: 'Behandlungen',
      gallery: 'Galerie',
      booking: 'Termin',
    },
    cta: {
      whatsapp: 'Termin per WhatsApp buchen',
      whatsappShort: 'WhatsApp',
      bookNow: 'Jetzt Termin sichern',
      discoverServices: 'Behandlungen entdecken',
    },
    grandOpening: {
      label: 'Neueröffnung — Einführungspreise bis',
    },
    seasonal: {
      badge: '❄ NEU · SOMMER EDITION',
      titleA: 'Ice Glass Skin',
      titleB: 'Recovery.',
      tagline: 'Die perfekte Erfrischung für heiße Sommertage.',
      description:
        'Ein exklusives koreanisches Cooling-Treatment für überhitzte, feuchtigkeitsarme und sonnengestresste Haut. Intensive Feuchtigkeit, sofortige Beruhigung und ein frischer Glass Skin Glow — die perfekte Pflege für heiße Sommertage.',
      priceLabel: 'Sommer Edition',
      price: '89 €',
      cta: 'Jetzt Termin buchen',
    },
    // Hero
    hero: {
      eyebrow: 'Erster koreanischer Hautpflege-Salon in Niedersachsen',
      titleA: 'Authentische ',
      titleB: 'koreanische Hautpflege',
      titleC: ' mit intensiven ',
      titleD: 'Gesichtsmassagen',
      tagline1: 'Glass Skin beginnt hier — ',
      tagline2: 'sichtbar',
      tagline3: ', spürbar und ',
      tagline4: 'nachhaltig.',
      bodyA:
        'Wir behandeln nicht nur — wir arbeiten gezielt mit deiner Haut. Durch spezielle Massagetechniken wird die Durchblutung aktiviert, die Haut revitalisiert und natürlich zum Strahlen gebracht.',
      bodyMission: 'Das ist mehr als eine Behandlung. Es ist meine persönliche Mission.',
      stats: {
        rating: '5-Sterne-Bewertung',
        certified: 'Südkorea zertifiziert',
        rituals: 'Signature Rituale',
      },
    },
    // Why Korean
    whyKorean: {
      eyebrow: 'Methode',
      titleA: 'Warum koreanische',
      titleB: 'Hautpflege?',
      p1:
        'Koreanische Hautpflege steht weltweit für präzise Techniken, innovative Ansätze und nachhaltige Ergebnisse.',
      p2:
        'Unsere Behandlungen basieren auf gezielten Gesichtsmassagen, lymphatischer Drainage und aktivierenden Lifting-Techniken.',
      p3:
        'Dabei wird die Durchblutung gefördert, die Haut intensiv stimuliert und ihre natürliche Regeneration unterstützt.',
      p4: 'Das Ergebnis: eine gesunde, strahlende Haut — nicht nur kurzfristig, sondern langfristig.',
    },
    // Trust / Certification
    trust: {
      eyebrow: 'Zertifizierung',
      titleA: 'Zertifiziert in',
      titleB: 'Südkorea',
      p1: 'Ausgebildet an einer international renommierten Akademie.',
    },
    // Philosophy
    philosophy: {
      eyebrow: 'Philosophie',
      unnieLabel: 'Unnie · 언니',
      unnieTitleA: '„Unnie" bedeutet im Koreanischen',
      unnieTitleB: '„große Schwester".',
      unnieIntro:
        'Es steht für Vertrauen, Fürsorge und persönliche Betreuung — genau dieses Gefühl möchten wir in jeder Behandlung vermitteln.',
      blocks: [
        {
          eyebrow: 'Essenz',
          title: 'Ein Ritual, keine Routine.',
          body:
            'Es gibt keine starre Routine. Jede Behandlung wird individuell auf den Hautzustand, die Hautziele und die Gesichtsmerkmale jeder Kundin abgestimmt.\n\nJedes Produkt, jeder Wirkstoff, jede Maske und jede Massagetechnik wird sorgfältig für jede Kundin einzeln ausgewählt.\n\nJede Behandlung ist einzigartig.',
        },
        {
          eyebrow: 'Ritual',
          title: 'Mehrstufige Pflege statt Standard.',
          body:
            'Jede Behandlung beginnt mit einer professionellen Hautanalyse und sorgfältigen Hautvorbereitung.\n\nDie Gesichts-, Hals- und Dekolleté-Massage wird individuell an Muskelspannung, Mimik, Linien und Bedürfnisse angepasst — inspiriert von traditionellen asiatischen Techniken wie Kobido und Gua Sha.\n\nSie regt die Durchblutung an, unterstützt den natürlichen Lymphfluss, entspannt die Gesichtsmuskulatur und schenkt einen natürlichen Lifting-Effekt sowie gesunden Glow.\n\nJede Behandlung wird mit individuell ausgewählten koreanischen Produkten, Wirkstoffen und Masken abgerundet.',
        },
        {
          eyebrow: 'Ansatz',
          title: 'Prävention statt Korrektur.',
          body:
            'Wir stärken die Hautbarriere, bevor sichtbare Probleme entstehen. Der Fokus liegt auf Hautgesundheit und langfristigen Ergebnissen — nicht auf kurzfristigen Effekten.',
        },
        {
          eyebrow: 'Ergebnis',
          title: 'Glass Skin Philosophie.',
          body:
            'Strahlende, glasklare Haut mit tiefer Feuchtigkeit, sichtbarem Glow und spürbarer Elastizität. Individuell abgestimmt auf deine Haut und deine Bedürfnisse.',
        },
      ],
      closingTitle: 'Frauen und Männer ',
      closingTitleAccent: 'gleichermaßen willkommen.',
      closingBody:
        'Koreanische Hautpflege wirkt unabhängig vom Geschlecht. Männerhaut profitiert besonders von professioneller Vorbereitung, Anti-Aging-Massage und gezielter Feuchtigkeitspflege.',
    },
    // Services
    services: {
      eyebrow: 'Preisliste',
      title: 'Behandlungen.',
      p1:
        'Jede Behandlung ist ein vollständiges Ritual — mehrstufige Reinigung, asiatische Massagetechniken (Gua Sha, Kobido, Schröpfen) und mehrere individuell abgestimmte Masken.',
      p2:
        'Wir arbeiten ausschließlich mit hochwertigen koreanischen Produkten und modernen Technologien wie Aqua Peel, RF Lifting, Mikrodermabrasion und LED-Lichttherapie.',
      promoBoxTitle: 'Exklusiv für Neukunden:',
      promoBoxAmount: '20 €',
      promoBoxAction: 'Rabatt',
      promoBoxFor: 'auf Ihre erste reguläre Behandlung',
      promoBoxOffer: '20 € Rabatt auf Ihre erste reguläre Behandlung',
      promoBoxNote: 'Einmalig pro Neukunde. Nicht mit anderen Aktionen oder Rabatten kombinierbar.',
      promoBadge: 'PROMO',
      individualLabel: 'Einzelbehandlungen',
      individualTitle: 'Alle Behandlungen.',
      includedInfo: 'Bei Unnie umfasst jede Behandlung immer Gesicht, Hals und Dekolleté — ohne Aufpreis.',
      premiumEyebrow: 'Premium Korean Beauty',
      premiumTitleA: 'Korean Beauty. Exklusive Pflege.',
      premiumTitleB: 'Purer Luxus.',
      premiumIntro: 'Gönnen Sie sich und Ihrer Haut etwas Besonderes.',
      premiumP1: 'Bei Unnie arbeiten wir mit sorgfältig ausgewählter, hochwertiger professioneller koreanischer Kosmetik und Premium-Wirkstoffen.',
      premiumP2: 'Jedes Produkt, jeder Wirkstoff, jede Maske und jeder Behandlungsschritt wird individuell auf die Haut jeder Kundin und ihre Bedürfnisse abgestimmt.',
      packagesLabel: 'Kurpaket',
      giftBadge: 'DAS PERFEKTE GESCHENK',
      giftNote: 'Ein besonderes koreanisches Beauty-Erlebnis zum Verschenken.',
      discountsExcluded: 'Dieses Treatment ist von allen Rabattaktionen ausgeschlossen.',
      ctaQuestion: 'Unsicher welche Behandlung?',
      ctaQuestionAccent: 'Wir beraten dich.',
    },
    // Cinderella
    cinderella: {
      eyebrow: 'Exklusives Hautpflegeprogramm',
      titleA: 'Cinderella',
      titleB: 'Skin Program.',
      developedBy: 'Entwickelt von Vivian Kim · Migwang Beauty Academy, Südkorea',
      p1:
        'Ein intensives Behandlungsprogramm für tiefgehende Regeneration, sichtbare Ergebnisse und langanhaltenden Glow.',
      p2:
        'Vier gezielte Schritte für Regeneration, Aufbau, Erneuerung und Verfeinerung des Hautbildes.',
      includesLabel: 'Programm umfasst',
      includes: [
        'Calming Care',
        'Oxygen Collagen Therapy',
        'Microneedling',
        'Return Care',
      ],
      rhythmLabel: 'Empfohlener Abstand zwischen den Behandlungen',
      rhythmInterval: '7–10 Tage',
      rhythm: [
        '4 Behandlungen innerhalb von 7–10 Tagen',
        'Bei der Folgebuchung flexible Terminplanung möglich',
      ],
      originalLabel: 'Wert der Einzelbehandlungen',
      originalValue: '466 €',
      introLabel: 'Einführungspreis für Neukundinnen',
      introPrice: '299 €',
      perTreatment: 'Nur ca. 75 € pro Behandlung',
      savingLabel: 'Sie sparen',
      savingAmount: '167 €',
      oneTime: 'Einmalig für Neukundinnen.',
      combinable: 'Nicht mit anderen Aktionen oder Rabatten kombinierbar.',
      followUpLabel: 'Folgebuchung Cinderella Programm',
      followUpPrice: '339 €',
      followUpPerTreatment: 'Nur ca. 85 € pro Behandlung',
      followUpNote: 'Bei der Folgebuchung können die Termine flexibel geplant werden.',
      creditOptionLabel: 'Flexibler Einstieg',
      creditOption:
        'Sie können zunächst mit einer Calming Care Behandlung beginnen. Wenn Sie sich nach der ersten Behandlung für das Cinderella Skin Program entscheiden, wird der Preis der Calming Care vollständig auf das Cinderella Programm angerechnet. Den Restbetrag zahlen Sie einfach beim zweiten Termin.',
      ctaBook: 'Cinderella buchen',
      steps: [
        {
          title: 'Calming Care',
          sub: 'Beruhigung & Hautvorbereitung',
          desc:
            'Intensiver und zugleich sanfter Einstieg in die koreanische Hautpflege — gründliche Reinigung, Beruhigung und optimale Vorbereitung der Haut auf weiterführende Behandlungen.\n\nGesichtsreinigung, Ultraschallreinigung, Radiofrequenz (RF) für Straffung und einen natürlichen Lifting-Effekt, intensive Gesichts-, Hals- und Dekolleté-Massage, zwei individuell ausgewählte Masken, LED-Therapie und Cold-Hammer-Kryotherapie.\n\nIdeal als erster Einstieg in die koreanische Hautpflege.',
        },
        {
          title: 'Oxygen Collagen Therapy',
          sub: 'Sauerstoff & Feuchtigkeit',
          desc:
            'Intensive Sauerstofftherapie mit tiefer Feuchtigkeitspflege — versorgt die Haut, unterstützt ihre Regeneration und hilft müde wirkender Haut, wieder frisch und revitalisiert auszusehen. Für mehr Ausstrahlung, einen gesunden Glow und ein gepflegtes Hautbild.\n\nGesichts-, Hals- und Dekolleté-Massage, zwei Masken, LED-Therapie und Cold-Hammer-Kryotherapie.\n\nBesonders empfohlen für trockene, müde und reife Haut.',
        },
        {
          title: 'Microneedling',
          sub: 'Hauterneuerung',
          desc:
            'Koreanische Premium-Wirkstoffe.\n\nVerbesserung von Aknenarben, Pigmentflecken und feinen Linien.\n\nMassage und LED-Therapie.\n\nAlternativ: Unnie\'s Lifting Session – die nadelfreie Alternative für natürliches Lifting.',
        },
        {
          title: 'Return Care',
          sub: 'Regeneration',
          desc:
            'Tiefenreinigung.\n\nUltraschall zur Unterstützung der Lymphdrainage.\n\nGesichts-, Hals- und Dekolleté-Massage.\n\nMaske.\n\nCold-Hammer-Kryotherapie.\n\nUnterstützt die Regeneration und reduziert Schwellungen.',
        },
      ],
    },
    // Gallery
    gallery: {
      eyebrow: 'Studio',
      title: 'Galerie.',
      subtitle: 'Einblicke in unsere Behandlungen',
      groupTrainingTitle: 'Training in South Korea',
      groupTrainingSub: 'Korea Mikwang Beauty Academy',
      groupExperienceTitle: 'Treatment Experience',
      groupExperienceSub: 'Massage · Facial · Entspannung',
      p1:
        'Momente aus dem Studio — Pflegerituale, Behandlungsräume und die Atmosphäre, die jede Behandlung zu einem Erlebnis macht.',
      p2:
        'Unser Studio in Bad Rothenfelde ist bewusst minimalistisch und ruhig gestaltet — ein Raum, in dem Haut und Geist zur Ruhe kommen.',
    },
    // Testimonials
    testimonials: {
      eyebrow: 'Kundenstimmen',
      title: 'Echte Stimmen unserer Kundinnen',
      subtitle: 'Basierend auf echten Google-Bewertungen',
    },
    // Booking
    booking: {
      eyebrow: 'Termin',
      titleA: 'Glass Skin',
      titleB: 'beginnt hier.',
      p1: 'Termine vereinbaren wir persönlich — wir beraten dich zu deinem Hauttyp und finden gemeinsam das passende Ritual.',
      p2: 'Schreib uns per WhatsApp für eine schnelle und unkomplizierte Terminbestätigung.',
      contact: { phone: 'Telefon', email: 'E-Mail', studio: 'Studio' },
    },
    // Footer
    footer: {
      tagline:
        'Authentische koreanische Hautpflege in Bad Rothenfelde — ein Ort für Ruhe, Ritual und sichtbare Hautgesundheit.',
      contact: 'Kontakt',
      hours: 'Öffnungszeiten',
      weekdays: 'Montag — Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
      sundayClosed: 'Geschlossen',
      rights: 'Alle Rechte vorbehalten',
    },
  },

  en: {
    nav: {
      home: 'Home',
      philosophy: 'Philosophy',
      services: 'Treatments',
      gallery: 'Gallery',
      booking: 'Booking',
    },
    cta: {
      whatsapp: 'Book via WhatsApp',
      whatsappShort: 'WhatsApp',
      bookNow: 'Book your appointment now',
      discoverServices: 'Discover treatments',
    },
    grandOpening: {
      label: 'Grand Opening — Introductory prices until',
    },
    seasonal: {
      badge: '❄ NEW · SUMMER EDITION',
      titleA: 'Ice Glass Skin',
      titleB: 'Recovery.',
      tagline: 'The perfect refreshment for hot summer days.',
      description:
        'An exclusive Korean cooling treatment for overheated, dehydrated and sun-stressed skin. Intensive hydration, instant soothing and a fresh Glass Skin glow — the perfect care for hot summer days.',
      priceLabel: 'Summer Edition',
      price: '89 €',
      cta: 'Book your appointment',
    },
    hero: {
      eyebrow: 'First Korean Skincare Salon in Lower Saxony',
      titleA: 'Authentic ',
      titleB: 'Korean skincare',
      titleC: ' with advanced ',
      titleD: 'facial massage techniques',
      tagline1: 'Glass skin begins here — ',
      tagline2: 'visible',
      tagline3: ', tangible and ',
      tagline4: 'long-lasting.',
      bodyA:
        'We don\'t just treat — we work deeply with your skin. Through targeted massage techniques, circulation is activated, the skin is revitalized and natural glow is restored.',
      bodyMission: 'This is more than a treatment. It is my personal mission.',
      stats: {
        rating: '5-Star Rating',
        certified: 'South Korea certified',
        rituals: 'Signature rituals',
      },
    },
    whyKorean: {
      eyebrow: 'Method',
      titleA: 'Why Korean',
      titleB: 'skincare?',
      p1:
        'Korean skincare is known worldwide for its precise techniques and long-term results.',
      p2:
        'Our treatments are based on targeted facial massage, lymphatic drainage and lifting techniques.',
      p3: 'These methods stimulate circulation, activate the skin and support natural regeneration.',
      p4: 'The result: healthy, glowing skin — long-term.',
    },
    trust: {
      eyebrow: 'Certification',
      titleA: 'Certified in',
      titleB: 'South Korea',
      p1: 'Trained at an internationally renowned academy.',
    },
    philosophy: {
      eyebrow: 'Philosophy',
      unnieLabel: 'Unnie · 언니',
      unnieTitleA: '"Unnie" means in Korean',
      unnieTitleB: '"big sister".',
      unnieIntro:
        'It stands for trust, care and personal attention — exactly the feeling we want to convey in every treatment.',
      blocks: [
        {
          eyebrow: 'Essence',
          title: 'A ritual, not a routine.',
          body:
            'There is no fixed routine. Every treatment is individually tailored to each client\'s skin condition, skin goals and facial characteristics.\n\nEvery product, every active ingredient, every mask and every massage technique is carefully selected for each client individually.\n\nEvery treatment is unique.',
        },
        {
          eyebrow: 'Ritual',
          title: 'Multi-step care, not standard.',
          body:
            'Every treatment begins with a professional skin analysis and careful skin preparation.\n\nThe facial, neck and décolleté massage is individually adapted to muscle tension, facial expressions, lines and the client\'s needs — inspired by traditional Asian techniques such as Kobido and Gua Sha.\n\nIt stimulates blood circulation, supports the natural lymphatic flow, relaxes facial muscles and creates a natural lifting effect and healthy glow.\n\nEvery treatment is completed with individually selected Korean products, active ingredients and masks.',
        },
        {
          eyebrow: 'Approach',
          title: 'Prevention, not correction.',
          body:
            'We strengthen the skin barrier before visible problems arise. The focus is on skin health and long-term results — not on short-term effects.',
        },
        {
          eyebrow: 'Result',
          title: 'Glass skin philosophy.',
          body:
            'Radiant, glass-clear skin with deep hydration, visible glow and tangible elasticity. Individually tailored to your skin and your needs.',
        },
      ],
      closingTitle: 'Women and men ',
      closingTitleAccent: 'equally welcome.',
      closingBody:
        'Korean skincare works regardless of gender. Men\'s skin particularly benefits from professional preparation, anti-aging massage and targeted hydration.',
    },
    services: {
      eyebrow: 'Price list',
      title: 'Treatments.',
      p1:
        'Each treatment is a complete ritual — multi-step cleansing, Asian massage techniques (Gua Sha, Kobido, cupping) and several individually selected masks.',
      p2:
        'We work exclusively with high-quality Korean products and modern technologies such as Aqua Peel, RF Lifting, microdermabrasion and LED light therapy.',
      promoBoxTitle: 'Exclusive for new clients:',
      promoBoxAmount: '€20',
      promoBoxAction: 'off',
      promoBoxFor: 'your first regular treatment',
      promoBoxOffer: '€20 off your first regular treatment',
      promoBoxNote: 'One-time per new client. Cannot be combined with other promotions or discounts.',
      promoBadge: 'PROMO',
      individualLabel: 'Individual treatments',
      individualTitle: 'All treatments.',
      includedInfo: 'At Unnie every treatment always includes face, neck and décolleté — at no extra charge.',
      premiumEyebrow: 'Premium Korean Beauty',
      premiumTitleA: 'Korean Beauty. Exclusive care.',
      premiumTitleB: 'Pure luxury.',
      premiumIntro: 'Treat yourself and your skin to something special.',
      premiumP1: 'At Unnie we work with carefully selected, high-quality professional Korean skincare and premium active ingredients.',
      premiumP2: 'Every product, every active ingredient, every mask and every treatment step is individually chosen for each client\'s skin and its needs.',
      packagesLabel: 'Treatment package',
      giftBadge: 'THE PERFECT GIFT',
      giftNote: 'A special Korean beauty experience to give as a gift.',
      discountsExcluded: 'This treatment is excluded from all discounts and promotional offers.',
      ctaQuestion: 'Unsure which treatment?',
      ctaQuestionAccent: 'We advise you.',
    },
    cinderella: {
      eyebrow: 'Exclusive skincare program',
      titleA: 'Cinderella',
      titleB: 'Skin Program.',
      developedBy: 'Developed by Vivian Kim · Migwang Beauty Academy, South Korea',
      p1: 'An intensive program for deep regeneration, visible results and long-lasting glow.',
      p2: 'Four targeted steps for regeneration, build-up, renewal and refinement of the skin.',
      includesLabel: 'Program includes',
      includes: ['Calming Care', 'Oxygen Collagen Therapy', 'Microneedling', 'Return Care'],
      rhythmLabel: 'Recommended interval between treatments',
      rhythmInterval: '7–10 days',
      rhythm: ['4 treatments within 7–10 days', 'Flexible scheduling for follow-up bookings'],
      originalLabel: 'Value of individual treatments',
      originalValue: '466 €',
      introLabel: 'Introductory price for new clients',
      introPrice: '299 €',
      perTreatment: 'Only approx. 75 € per treatment',
      savingLabel: 'You save',
      savingAmount: '167 €',
      oneTime: 'One-time offer for new clients.',
      combinable: 'Cannot be combined with other promotions or discounts.',
      followUpLabel: 'Cinderella program — follow-up booking',
      followUpPrice: '339 €',
      followUpPerTreatment: 'Only approx. 85 € per treatment',
      followUpNote: 'For follow-up bookings, appointments can be scheduled flexibly.',
      creditOptionLabel: 'Flexible entry option',
      creditOption:
        'You can start with a single Calming Care treatment. If you decide on the Cinderella Skin Program after the first treatment, the price of Calming Care will be fully credited to the Cinderella Program. You simply pay the remaining amount at the second appointment.',
      ctaBook: 'Book Cinderella',
      steps: [
        {
          title: 'Calming Care',
          sub: 'Calming & skin preparation',
          desc:
            'An intensive yet gentle introduction to Korean skincare — thorough cleansing, calming and optimal preparation of the skin for further treatments.\n\nFacial cleansing, ultrasonic cleansing, radiofrequency (RF) for firming and a natural lifting effect, intensive facial, neck and décolleté massage, two individually selected masks, LED therapy and Cold-Hammer cryotherapy.\n\nIdeal as a first introduction to Korean skincare.',
        },
        {
          title: 'Oxygen Collagen Therapy',
          sub: 'Oxygen & hydration',
          desc:
            'Intensive oxygen therapy with deep hydration — nourishes the skin, supports its regeneration and helps tired-looking skin appear fresh and revitalized. For more radiance, a healthy glow and a cared-for complexion.\n\nFacial, neck and décolleté massage, two masks, LED therapy and Cold-Hammer cryotherapy.\n\nEspecially recommended for dry, tired and mature skin.',
        },
        {
          title: 'Microneedling',
          sub: 'Skin renewal',
          desc:
            'Korean premium active ingredients.\n\nImprovement of acne scars, pigmentation and fine lines.\n\nMassage and LED therapy.\n\nAlternative: Unnie\'s Lifting Session — the needle-free alternative for natural lifting.',
        },
        {
          title: 'Return Care',
          sub: 'Regeneration',
          desc:
            'Deep cleansing.\n\nUltrasound to support lymphatic drainage.\n\nFacial, neck and décolleté massage.\n\nMask.\n\nCold-Hammer cryotherapy.\n\nSupports regeneration and reduces swelling.',
        },
      ],
    },
    gallery: {
      eyebrow: 'Studio',
      title: 'Gallery.',
      subtitle: 'Glimpses into our treatments',
      groupTrainingTitle: 'Training in South Korea',
      groupTrainingSub: 'Korea Mikwang Beauty Academy',
      groupExperienceTitle: 'Treatment Experience',
      groupExperienceSub: 'Massage · Facial · Relaxation',
      p1:
        'Moments from the studio — care rituals, treatment rooms and the atmosphere that turns every treatment into an experience.',
      p2:
        'Our studio in Bad Rothenfelde is deliberately minimalist and calm — a space where skin and mind find peace.',
    },
    testimonials: {
      eyebrow: 'Reviews',
      title: 'Real voices from our clients',
      subtitle: 'Based on real Google reviews',
    },
    booking: {
      eyebrow: 'Booking',
      titleA: 'Glass skin',
      titleB: 'begins here.',
      p1:
        'We arrange appointments personally — we advise you on your skin type and find the right ritual together.',
      p2: 'Message us via WhatsApp for quick and easy appointment confirmation.',
      contact: { phone: 'Phone', email: 'Email', studio: 'Studio' },
    },
    footer: {
      tagline:
        'Authentic Korean skincare in Bad Rothenfelde — a place for calm, ritual and visible skin health.',
      contact: 'Contact',
      hours: 'Opening hours',
      weekdays: 'Monday — Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      sundayClosed: 'Closed',
      rights: 'All rights reserved',
    },
  },

  pl: {
    nav: {
      home: 'Start',
      philosophy: 'Filozofia',
      services: 'Zabiegi',
      gallery: 'Galeria',
      booking: 'Wizyta',
    },
    cta: {
      whatsapp: 'Umów wizytę przez WhatsApp',
      whatsappShort: 'WhatsApp',
      bookNow: 'Zarezerwuj wizytę',
      discoverServices: 'Zobacz zabiegi',
    },
    grandOpening: {
      label: 'Otwarcie — ceny promocyjne do',
    },
    seasonal: {
      badge: '❄ NOWOŚĆ · EDYCJA LATO',
      titleA: 'Ice Glass Skin',
      titleB: 'Recovery.',
      tagline: 'Idealne odświeżenie na upalne dni.',
      description:
        'Ekskluzywny koreański zabieg chłodzący dla przegrzanej, odwodnionej i zestresowanej słońcem skóry. Intensywne nawilżenie, natychmiastowe ukojenie i świeży Glass Skin glow — idealna pielęgnacja na gorące letnie dni.',
      priceLabel: 'Edycja Lato',
      price: '89 €',
      cta: 'Zarezerwuj wizytę',
    },
    hero: {
      eyebrow: 'Pierwszy salon koreańskiej pielęgnacji w Dolnej Saksonii',
      titleA: 'Autentyczna ',
      titleB: 'koreańska pielęgnacja',
      titleC: ' z intensywnym ',
      titleD: 'masażem twarzy',
      tagline1: 'Glass Skin zaczyna się tutaj — ',
      tagline2: 'widocznie',
      tagline3: ', odczuwalnie i ',
      tagline4: 'długotrwale.',
      bodyA:
        'Nie działamy tylko powierzchownie — pracujemy ze skórą. Dzięki specjalnym technikom masażu pobudzamy krążenie, rewitalizujemy skórę i przywracamy jej naturalny blask.',
      bodyMission: 'To coś więcej niż zabieg. To moja osobista misja.',
      stats: {
        rating: 'Ocena 5 Gwiazdek',
        certified: 'Korea Płd. — certyfikat',
        rituals: 'Rytuały Signature',
      },
    },
    whyKorean: {
      eyebrow: 'Metoda',
      titleA: 'Dlaczego koreańska',
      titleB: 'pielęgnacja?',
      p1:
        'Koreańska pielęgnacja jest znana na całym świecie dzięki precyzyjnym technikom i długotrwałym efektom.',
      p2:
        'Nasze zabiegi opierają się na ukierunkowanym masażu twarzy, drenażu limfatycznym oraz technikach liftingujących.',
      p3: 'Pobudzamy krążenie, aktywujemy skórę i wspieramy jej naturalną regenerację.',
      p4: 'Efekt: zdrowa, promienna skóra — na dłużej.',
    },
    trust: {
      eyebrow: 'Certyfikat',
      titleA: 'Certyfikowana w',
      titleB: 'Korei Południowej',
      p1: 'Wykształcona w międzynarodowo renomowanej akademii.',
    },
    philosophy: {
      eyebrow: 'Filozofia',
      unnieLabel: 'Unnie · 언니',
      unnieTitleA: '„Unnie" w języku koreańskim oznacza',
      unnieTitleB: '„starsza siostra".',
      unnieIntro:
        'To zaufanie, troska i osobista uwaga — dokładnie to uczucie chcemy przekazać w każdym zabiegu.',
      blocks: [
        {
          eyebrow: 'Esencja',
          title: 'Rytuał, nie rutyna.',
          body:
            'Nie ma jednej rutyny. Każdy zabieg jest indywidualnie dopasowany do kondycji skóry, celów pielęgnacyjnych i cech twarzy każdej klientki.\n\nKażdy produkt, składnik aktywny, maska i technika masażu są starannie dobierane dla każdej klientki z osobna.\n\nKażdy zabieg jest wyjątkowy.',
        },
        {
          eyebrow: 'Rytuał',
          title: 'Wieloetapowa pielęgnacja zamiast standardu.',
          body:
            'Każdy zabieg rozpoczyna się od profesjonalnej analizy skóry i starannego przygotowania.\n\nMasaż twarzy, szyi i dekoltu jest indywidualnie dopasowany do napięcia mięśniowego, mimiki, linii i potrzeb klientki — inspirowany tradycyjnymi azjatyckimi technikami Kobido i Gua Sha.\n\nPobudza krążenie, wspiera naturalny przepływ limfy, rozluźnia mięśnie twarzy i tworzy naturalny efekt liftingu oraz zdrowy blask.\n\nKażdy zabieg kończy się indywidualnie dobranymi koreańskimi produktami, składnikami aktywnymi i maskami.',
        },
        {
          eyebrow: 'Podejście',
          title: 'Profilaktyka zamiast korekty.',
          body:
            'Wzmacniamy barierę skórną zanim pojawią się widoczne problemy. Skupiamy się na zdrowiu skóry i długofalowych efektach — nie chwilowych.',
        },
        {
          eyebrow: 'Efekt',
          title: 'Filozofia Glass Skin.',
          body:
            'Promienna, szklisto czysta skóra z głębokim nawilżeniem, widocznym blaskiem i odczuwalną elastycznością. Indywidualnie dopasowana do Ciebie.',
        },
      ],
      closingTitle: 'Kobiety i mężczyźni ',
      closingTitleAccent: 'jednakowo mile widziani.',
      closingBody:
        'Koreańska pielęgnacja działa niezależnie od płci. Skóra mężczyzn szczególnie zyskuje na profesjonalnym przygotowaniu, masażu anti-aging i ukierunkowanym nawilżaniu.',
    },
    services: {
      eyebrow: 'Cennik',
      title: 'Zabiegi.',
      p1:
        'Każdy zabieg to pełny rytuał — wieloetapowe oczyszczanie, azjatyckie techniki masażu (Gua Sha, Kobido, bańki) i kilka indywidualnie dobranych masek.',
      p2:
        'Pracujemy wyłącznie z wysokiej jakości koreańskimi produktami i nowoczesnymi technologiami: Aqua Peel, RF Lifting, mikrodermabrazja, terapia LED.',
      promoBoxTitle: 'Wyłącznie dla nowych klientek:',
      promoBoxAmount: '20 €',
      promoBoxAction: 'zniżki',
      promoBoxFor: 'na pierwszy regularny zabieg',
      promoBoxOffer: '20 € zniżki na pierwszy regularny zabieg',
      promoBoxNote: 'Jednorazowo na nową klientkę. Nie łączy się z innymi promocjami ani rabatami.',
      promoBadge: 'PROMO',
      individualLabel: 'Pojedyncze zabiegi',
      individualTitle: 'Wszystkie zabiegi.',
      includedInfo: 'W Unnie każdy zabieg zawsze obejmuje twarz, szyję i dekolt — bez dodatkowych opłat.',
      premiumEyebrow: 'Premium Korean Beauty',
      premiumTitleA: 'Korean Beauty. Ekskluzywna pielęgnacja.',
      premiumTitleB: 'Czysty luksus.',
      premiumIntro: 'Podaruj sobie i swojej skórze coś wyjątkowego.',
      premiumP1: 'W Unnie pracujemy ze starannie wybraną, wysokiej jakości profesjonalną koreańską kosmetyką i składnikami aktywnymi premium.',
      premiumP2: 'Każdy produkt, każdy składnik aktywny, każda maska i każdy krok zabiegu są indywidualnie dobierane do skóry klientki i jej potrzeb.',
      packagesLabel: 'Pakiet zabiegowy',
      giftBadge: 'IDEALNY PREZENT',
      giftNote: 'Wyjątkowe koreańskie doświadczenie beauty na prezent.',
      discountsExcluded: 'Ten zabieg jest wyłączony ze wszystkich promocji i rabatów.',
      ctaQuestion: 'Nie wiesz który zabieg wybrać?',
      ctaQuestionAccent: 'Doradzimy.',
    },
    cinderella: {
      eyebrow: 'Ekskluzywny program pielęgnacyjny',
      titleA: 'Cinderella',
      titleB: 'Skin Program.',
      developedBy: 'Opracowany przez Vivian Kim · Migwang Beauty Academy, Korea Płd.',
      p1: 'Intensywny program dla głębokiej regeneracji, widocznych efektów i długotrwałego glow.',
      p2:
        'Cztery ukierunkowane kroki dla regeneracji, odbudowy, odnowy i wygładzenia skóry.',
      includesLabel: 'Program obejmuje',
      includes: ['Calming Care', 'Oxygen Collagen Therapy', 'Microneedling', 'Return Care'],
      rhythmLabel: 'Zalecany odstęp między zabiegami',
      rhythmInterval: '7–10 dni',
      rhythm: ['4 zabiegi w ciągu 7–10 dni', 'Przy ponownej rezerwacji elastyczne planowanie terminów'],
      originalLabel: 'Wartość pojedynczych zabiegów',
      originalValue: '466 €',
      introLabel: 'Cena wprowadzająca dla nowych klientek',
      introPrice: '299 €',
      perTreatment: 'Tylko ok. 75 € za zabieg',
      savingLabel: 'Oszczędzasz',
      savingAmount: '167 €',
      oneTime: 'Jednorazowo dla nowych klientek.',
      combinable: 'Nie łączy się z innymi promocjami ani rabatami.',
      followUpLabel: 'Cinderella Program — ponowna rezerwacja',
      followUpPrice: '339 €',
      followUpPerTreatment: 'Tylko ok. 85 € za zabieg',
      followUpNote: 'Przy ponownej rezerwacji terminy można planować elastycznie.',
      creditOptionLabel: 'Elastyczny start',
      creditOption:
        'Możesz najpierw rozpocząć od pojedynczego zabiegu Calming Care. Jeśli po pierwszym zabiegu zdecydujesz się na Cinderella Skin Program, cena Calming Care zostanie w pełni zaliczona na poczet programu. Pozostałą kwotę zapłacisz po prostu przy drugim terminie.',
      ctaBook: 'Zarezerwuj Cinderella',
      steps: [
        {
          title: 'Calming Care',
          sub: 'Ukojenie i przygotowanie skóry',
          desc:
            'Intensywne, a jednocześnie delikatne wprowadzenie do koreańskiej pielęgnacji — dokładne oczyszczenie, ukojenie i optymalne przygotowanie skóry do dalszych zabiegów.\n\nOczyszczanie twarzy, oczyszczanie ultradźwiękami, radiofrekwencja (RF) dla ujędrnienia i naturalnego efektu liftingu, intensywny masaż twarzy, szyi i dekoltu, dwie indywidualnie dobrane maski, terapia LED oraz krioterapia Cold-Hammer.\n\nIdealny jako pierwsze wprowadzenie do koreańskiej pielęgnacji.',
        },
        {
          title: 'Oxygen Collagen Therapy',
          sub: 'Tlen i nawilżenie',
          desc:
            'Intensywna terapia tlenowa z głębokim nawilżeniem — odżywia skórę, wspiera jej regenerację i pomaga zmęczonej skórze odzyskać świeżość i witalność. Dla większego blasku, zdrowego glow i zadbanej cery.\n\nMasaż twarzy, szyi i dekoltu, dwie maski, terapia LED i krioterapia Cold-Hammer.\n\nSzczególnie polecany dla skóry suchej, zmęczonej i dojrzałej.',
        },
        {
          title: 'Microneedling',
          sub: 'Odnowa skóry',
          desc:
            'Koreańskie premium składniki aktywne.\n\nRedukcja blizn potrądzikowych, przebarwień i drobnych zmarszczek.\n\nMasaż i terapia LED.\n\nAlternatywnie: Unnie\'s Lifting Session — bezigłowa alternatywa dla naturalnego liftingu.',
        },
        {
          title: 'Return Care',
          sub: 'Regeneracja',
          desc:
            'Głębokie oczyszczanie.\n\nUltradźwięki wspomagające drenaż limfatyczny.\n\nMasaż twarzy, szyi i dekoltu.\n\nMaska.\n\nKrioterapia Cold-Hammer.\n\nWspiera regenerację i redukuje obrzęki.',
        },
      ],
    },
    gallery: {
      eyebrow: 'Studio',
      title: 'Galeria.',
      subtitle: 'Zajrzyj do naszych zabiegów',
      groupTrainingTitle: 'Szkolenie w Korei Południowej',
      groupTrainingSub: 'Korea Mikwang Beauty Academy',
      groupExperienceTitle: 'Doświadczenie zabiegu',
      groupExperienceSub: 'Masaż · Twarz · Relaks',
      p1:
        'Momenty ze studia — rytuały pielęgnacyjne, gabinety i atmosfera, która zamienia każdy zabieg w doświadczenie.',
      p2:
        'Nasze studio w Bad Rothenfelde jest świadomie minimalistyczne i spokojne — przestrzeń, w której skóra i umysł znajdują wytchnienie.',
    },
    testimonials: {
      eyebrow: 'Opinie',
      title: 'Prawdziwe opinie naszych klientek',
      subtitle: 'Na podstawie autentycznych opinii Google',
    },
    booking: {
      eyebrow: 'Wizyta',
      titleA: 'Glass Skin',
      titleB: 'zaczyna się tutaj.',
      p1:
        'Wizyty umawiamy osobiście — doradzamy w doborze rytuału i dopasowujemy zabieg do Twojej skóry.',
      p2: 'Napisz do nas na WhatsApp — szybkie i wygodne potwierdzenie wizyty.',
      contact: { phone: 'Telefon', email: 'E-mail', studio: 'Studio' },
    },
    footer: {
      tagline:
        'Autentyczna koreańska pielęgnacja w Bad Rothenfelde — miejsce ciszy, rytuału i widocznego zdrowia skóry.',
      contact: 'Kontakt',
      hours: 'Godziny otwarcia',
      weekdays: 'Poniedziałek — Piątek',
      saturday: 'Sobota',
      sunday: 'Niedziela',
      sundayClosed: 'Zamknięte',
      rights: 'Wszelkie prawa zastrzeżone',
    },
  },
};

export const supportedLanguages = ['de', 'en', 'pl'];
